export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15022.73813e97.jpg";